import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getFuturePlan, getCurrentCellularPricePlan} from '../../../Block/ChangePricePlanBlock/changePricePlanSlice';
import Skeleton from 'react-loading-skeleton';
import {isMobile} from 'react-device-detect';
import 'react-loading-skeleton/dist/skeleton.css';

const TooltipFuturePackageInfo = (props) => {
  const [visible, setVisible] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);
  const infoIcon = props.icon ?? require('../images/moreInfo.svg');

  useEffect(() => {
    setCurrentPackage(null);
    setVisible(false);
  }, [props.selectedSubscriber?.productSubscriberNo]);

  const getPackageInfo = async () => {
    if (props.futurePackageInfo) {
      setCurrentPackage(props.futurePackageInfo);
    } else {
      const currentSub = props.subscriberByProduct[props.selectedSubscriber?.productType].find(
        (sub) => sub.productSubscriberNo === props.selectedSubscriber?.productSubscriberNo,
      );
      if (!currentPackage) {
        if (props.isImmediate) {
          await props.getCurrentCellularPricePlan({subscriberNo: currentSub.productSubscriberNo}).then((res) => {
            setCurrentPackage(res.payload.data.pp_details_desc);
          });
        } else {
          await props.getFuturePlan({subscriberNo: currentSub.productSubscriberNo, ban: currentSub.ban}).then((res) => {
            setCurrentPackage(res.payload.data.desc);
          });
        }
      }
    }
  };

  return (
    <div
      className='TooltipPackage-container'
      onMouseEnter={() => {
        setVisible(true);
        getPackageInfo();
      }}
      onMouseLeave={() => setVisible(false)}>
      <Image src={infoIcon} height={24} width={24} />
      {visible && (
        <>
          <div className={`tooltipPackage  right`}>
            <div className={`right pointer`}> </div>
            <div className='PackageInfo_text'>
              {currentPackage ? (
                <>
                  <p className='title'>מה בחבילה ? </p>
                  <p className='text'>{currentPackage}</p>
                </>
              ) : (
                <Skeleton count={isMobile ? 10 : 5} />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType,
    selectedSubscriber: state.selfcarePage?.selectedSubscriber,
    subscriberByProduct: state.selfcarePage?.subscribersByProduct,
  };
};

const mapDispatchToProps = {
  getFuturePlan,
  getCurrentCellularPricePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(TooltipFuturePackageInfo);
